module.exports = __webpack_public_path__ + "assets/img/1.81bc89ed.jpg";